module.exports = __webpack_public_path__ + "img/IMG_5418.7c2ba5b1.jpg";